import styleInject from '../../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".spoke-request-confirmation-summary{background:var(--swan-sem-color-bg-strong);border-radius:var(--swan-sem-border-radius-container);gap:var(--swan-sem-space-between-sections);padding:var(--swan-sem-space-6)}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
